define.alias("shared/components/shared/ui/social-set-switcher/list", "settings/components/shared/ui/social-set-switcher/list");